<template>
  <v-dialog
    v-model="showDialog"
    persistent
    max-width="700px"
  >
    <template #activator="{}">
      <v-tooltip
        bottom
        max-width="200px"
        open-delay="750"
      >
        <template #activator="{ on, attrs }">
          <div v-on="on">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="showDialog = true"
            >
              <v-icon
                :class="spinIcon ? 'fa-spin' : ''"
                :color="showLicenseExpirationWarning ? 'warning' : ''"
              >
                fa-file-alt
              </v-icon>
            </v-btn>
          </div>
        </template>
        <span>
          Lizenzinformationen
        </span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="auto">
            <h3>Lizenzinformationen</h3>
          </v-col>
          <v-spacer />
          <v-col cols="auto">
            <v-btn
              icon
              @click="showDialog = false"
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-alert
          elevation="2"
          border="top"
          colored-border
          :type="showLicenseExpirationWarning ? 'warning' : 'info'"
          class="mt-3"
        >
          <p>
            Typ: {{ user && user.license ? user.license.type : null }}<br>
            Ablaufdatum:
            <span :class="showLicenseExpirationWarning ? 'warning--text': ''">
              {{ licenseExpiredDate }}
            </span>
          </p>
          <p v-if="showLicenseExpirationWarning">
            Ihre Lizenz läuft bald ab.
            Wenn Sie eine Erneuerung Ihrer Lizenz wünschen, kontaktieren Sie uns unter
            <a href="mailto:quanticy@spicetech.de">quanticy@spicetech.de</a>.
          </p>
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showDialog: false,
      spinIcon: false
    };
  },
  computed: {
    ...mapGetters(['user']),
    licenseEnd() {
      return this?.user?.license?.end
    },
    // string representation of expiration date
    licenseExpiredDate() {
      return this.licenseEnd ? new Date(this.licenseEnd).toLocaleDateString('de-DE') : null;
    },
    // show license expiration warning when the license expires <= 14 days
    showLicenseExpirationWarning() {
      let nowPlus14Days = new Date();
      nowPlus14Days.setDate(nowPlus14Days.getDate() + 14);
      return this.licenseEnd ? new Date(this.licenseEnd) <= nowPlus14Days : null;
    }
  },
  watch: {
    // trigger icon spin as warning
    showLicenseExpirationWarning(newVal) {
      if (newVal) {
        this.spinIcon = true;
        setTimeout(() => this.spinIcon = false, 2000);
      }
    }
  }
}
</script>
